export default __webpack_public_path__ + "static/media/general-selected.96eb8546.svg";